import React, { useState, useEffect, useCallback, useRef } from 'react';
import { TabBar } from '../TabManager';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';
import { ChangeUsesDialog, AfterMoveAsk, MsgBox, makeApi } from '../Tadarokat/basicShared';

const incomeApi = makeApi('/api/income');

const toFa=n=>n==null?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const numFmt=n=>{const v=Number(n||0);return v===0?'':v.toLocaleString('fa-IR');};
const API=(path,opts={})=>fetch(`/api/income${path}`,{headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts}).then(jsonOf, netErr);

/* Autocomplete شهر */
function CityLookup({value,displayName,onChange,onSearch}){
  const [query,setQuery]=useState(displayName||'');
  const [open,setOpen]=useState(false);
  const [cities,setCities]=useState([]);
  const ref=useRef();

  useEffect(()=>{setQuery(displayName||'');},[displayName]);
  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener('mousedown',h);return()=>document.removeEventListener('mousedown',h);
  },[]);

  const doSearch=async(q)=>{
    setQuery(q);setOpen(true);
    if(!q.trim()){onChange(0,'');return;}
    try{
      const d=await API(`/departments/lookup/city/?q=${encodeURIComponent(q)}`);
      if(d.ok)setCities((d.rows||[]).map(c=>({id:c.id,city_code:c.code,name:c.title})));
    }catch(e){console.error(e);}
  };
  const select=c=>{onChange(c.id,c.name);setQuery(c.name);setOpen(false);};

  return(
    <div ref={ref} style={{position:'relative',flex:'0 0 48%'}}>
      <label style={{fontSize:'12px',fontWeight:'600',color:'#555',display:'block',marginBottom:'4px'}}>شهر</label>
      <input value={query} onChange={e=>doSearch(e.target.value)} onFocus={()=>{if(cities.length)setOpen(true);}}
        placeholder="جستجوی شهر..." style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',
          fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',width:'100%',boxSizing:'border-box'}}/>
      {open&&cities.length>0&&(
        <div style={{position:'absolute',top:'100%',right:0,left:0,background:'#fff',border:'1px solid #ccc',
          borderRadius:'8px',maxHeight:'200px',overflowY:'auto',zIndex:50,boxShadow:'0 8px 24px rgba(0,0,0,0.2)'}}>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'12px'}}>
            <thead><tr style={{background:'#f0f2f7',position:'sticky',top:0}}>
              <th style={{padding:'6px',borderBottom:'1px solid #ddd'}}>کد</th>
              <th style={{padding:'6px',textAlign:'right',borderBottom:'1px solid #ddd'}}>عنوان</th>
            </tr></thead>
            <tbody>{cities.slice(0,15).map(c=>(
              <tr key={c.id} onClick={()=>select(c)} style={{cursor:'pointer'}}
                onMouseEnter={e=>e.currentTarget.style.background='#e3f2fd'}
                onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                <td style={{padding:'5px 8px',textAlign:'center',borderBottom:'1px solid #f0f0f0'}}>{toFa(c.city_code)}</td>
                <td style={{padding:'5px 8px',textAlign:'right',borderBottom:'1px solid #f0f0f0'}}>{c.name}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const FInput=({label,name,value,onChange,readOnly,half,type='text'})=>(
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex:half?'0 0 48%':1}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <input name={name} type={type} value={value} onChange={onChange} readOnly={readOnly}
      style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',
        width:'100%',boxSizing:'border-box',background:readOnly?'#f5f5f5':'#fff'}}/>
  </div>
);

/* عرض ستون‌ها */
const INIT_WIDTHS=[50,70,70,220,150,100,100,100,150,80,90,80];
const EMPTY={code:0,cms_code:0,title:'',brief_name:'',national_code:'',pay_id_no:'',city_id:0,city_name:''};

export default function DepartmentList({user,onBack}){
  // دکمه‌های فرم FRMDEPARTMENTS؛ دیدن = دسترسی
  const vbf = useFormButtons('FRMDEPARTMENTS', ["BTNNEW","BTNEDIT","BTNDEPARTMENTSMANAGER","BTNDELETE","BTNOK","BTNCHANGEID","BTNMOVE"]);
  // دکمه‌های فرم FRMDEPARTMENTSMANAGER؛ دیدن = دسترسی
  const vbf_departmentsmanager = useFormButtons('FRMDEPARTMENTSMANAGER', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [hasMore,setHasMore]=useState(false);
  const [loading,setLoading]=useState(false);
  const [selected,setSelected]=useState(null);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState(EMPTY);
  const [error,setError]=useState('');
  const [toast,setToast]=useState('');
  const [mgrModal,setMgrModal]=useState(false);
  const [managers,setManagers]=useState([]);
  const [mgrDate,setMgrDate]=useState('');
  const [mgrPeopleId,setMgrPeopleId]=useState(0);
  const [mgrPeopleName,setMgrPeopleName]=useState('');
  const [peopleResults,setPeopleResults]=useState([]);
  const [peopleOpen,setPeopleOpen]=useState(false);
  const [mgrEditId,setMgrEditId]=useState(0);
  const [changing,setChanging]=useState(false);
  const [afterMove,setAfterMove]=useState(false);
  const [msgLines,setMsgLines]=useState([]);
  const peopleRef=useRef();
  const offsetRef=useRef(0);

  const {widths,TH}=useColumnResize(INIT_WIDTHS);
  const {visibleRows,search,setSearch,totalCount,LoadMoreButton}=useTablePagination({
    allRows:rows,searchFields:['title','brief_name','national_code'],serverTotal:total,serverHasMore:hasMore,
  });

  const fetchData=useCallback(async(reset=false)=>{
    if(reset){offsetRef.current=0;setRows([]);}
    setLoading(true);
    try{
      const off=reset?0:offsetRef.current;
      const d=await API(`/departments/?offset=${off}`);
      if(d.ok){setRows(p=>reset?d.rows:[...p,...d.rows]);setTotal(d.total);setHasMore(d.has_more);
        offsetRef.current=(reset?0:offsetRef.current)+d.rows.length;}
    }catch(e){console.error(e);}
    setLoading(false);
  },[]);
  useEffect(()=>{fetchData(true);},[]);

  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(''),2500);};
  const handleChange=e=>{const{name,value}=e.target;setForm(p=>({...p,[name]:value}));};

  const openNew=()=>{ if (!vbf.can('BTNNEW')) return;setForm(EMPTY);setError('');setModal('new');};
  const openEdit=()=>{ if (!vbf.can('BTNEDIT')) return;
    if(!selected)return;
    setForm({code:selected.code,cms_code:selected.cms_code,title:selected.title,brief_name:selected.brief_name,
      national_code:selected.national_code,pay_id_no:selected.pay_id_no,city_id:selected.city_id,city_name:selected.city_name});
    setError('');setModal('edit');
  };
  const handleSave=async()=>{
    if(!form.title.trim()){setError('عنوان الزامی است');return;}
    setError('');
    const payload={...form,code:+form.code,cms_code:+form.cms_code,city_id:+form.city_id};
    const url=modal==='new'?'/departments/create/':`/departments/${selected.id}/update/`;
    const d=await API(url,{method:'POST',body:JSON.stringify(payload)});
    if(d.ok){setModal(null);fetchData(true);showToast(modal==='new'?'✅ ثبت شد':'✅ ویرایش شد');}
    else setError(d.msg||d.error||'');
  };
  const handleDelete=async()=>{
    if(!selected)return;
    const d=await API(`/departments/${selected.id}/delete/`,{method:'POST'});
    if(d.ok){setModal(null);setSelected(null);fetchData(true);showToast('✅ حذف شد');}
    else {setModal(null);setMsgLines([d.msg||d.error||'خطا']);}
  };

  /* ── مسئول واحد ── */
  const openManagers=async()=>{ if (!vbf.can('BTNDEPARTMENTSMANAGER')) return;
    if(!selected)return;
    const d=await API(`/departments/${selected.id}/managers/`);
    if(d.ok)setManagers(d.rows||[]);
    setMgrDate('');setMgrPeopleId(0);setMgrPeopleName('');setMgrEditId(0);setMgrModal(true);
  };
  const searchPeople=async(q)=>{
    setMgrPeopleName(q);setPeopleOpen(true);
    if(!q.trim()){setPeopleResults([]);return;}
    const d=await API(`/people/search/?q=${encodeURIComponent(q)}`);
    if(d.ok)setPeopleResults(d.rows||[]);
  };
  const selectPerson=(p)=>{setMgrPeopleId(p.id);setMgrPeopleName(p.name);setPeopleOpen(false);};
  const addManager=async()=>{
    if(!vbf_departmentsmanager.can('BTNOK')||!vbf_departmentsmanager.can(mgrEditId?'BTNEDIT':'BTNNEW')) return;
    const body=JSON.stringify({people_id:mgrPeopleId,date:mgrDate});
    const d=mgrEditId
      ? await API(`/managers/${mgrEditId}/update/`,{method:'POST',body})
      : await API(`/departments/${selected.id}/managers/create/`,{method:'POST',body});
    if(d.ok){showToast('✅ ثبت شد');openManagers();}else setMsgLines([d.msg||d.error||'خطا']);
  };
  const editManager=m=>{setMgrEditId(m.id);setMgrPeopleId(m.people_id);setMgrPeopleName(m.name);setMgrDate(m.date);};
  const deleteManager=async(mid)=>{
    if(!window.confirm('آيا از حذف اين رکورد مطمئن هستيد؟'))return;
    const d=await API(`/managers/${mid}/delete/`,{method:'POST'});
    if(d.ok){showToast('✅ حذف شد');openManagers();}else setMsgLines([d.msg||d.error||'خطا']);
  };

  useEffect(()=>{
    const h=e=>{if(peopleRef.current&&!peopleRef.current.contains(e.target))setPeopleOpen(false);};
    document.addEventListener('mousedown',h);return()=>document.removeEventListener('mousedown',h);
  },[]);

  return(
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="" style={{width:'34px',height:'34px',borderRadius:'7px'}}/></div>
          <div><div style={s.hTitle}>واحدهای اجرایی</div><div style={s.hSub}>بخش درآمد — سامانه ارجان</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.toolbar}>
          <div style={s.toolBtns}>
            {vbf.can('BTNNEW') && <button onClick={openNew} style={s.btnNew}>＋ جدید</button>}
            {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{...s.btnEdit,opacity:selected?1:.4}}>✎ ویرایش</button>}
            {vbf.can('BTNDELETE') && <button onClick={()=>{if(selected){setError('');setModal('delete');}}} disabled={!selected} style={{...s.btnDel,opacity:selected?1:.4}}>✕ حذف</button>}
            {vbf.can('BTNDEPARTMENTSMANAGER') && <button onClick={openManagers} disabled={!selected} style={{...s.btnMgr,opacity:selected?1:.4}}>👤 مسئول واحد</button>}
            {vbf.can('BTNCHANGEID') && <button onClick={()=>{if(selected)setChanging(true);}} disabled={!selected} style={{...s.btnMgr,background:'linear-gradient(135deg,#4a148c,#6a1b9a)',opacity:selected?1:.4}}>تغییر موارد استفاده</button>}
          </div>
          <div style={{marginRight:'auto',display:'flex',alignItems:'flex-end',gap:'8px'}}>
            <div><div style={s.fL}>جستجو</div><input value={search} onChange={e=>setSearch(e.target.value)} placeholder="عنوان / کد..." style={{...s.fI,width:'220px'}}/></div>
          </div>
          <button onClick={()=>fetchData(true)} style={s.btnRefresh}>🔄</button>
          <div style={s.countBadge}>{toFa(visibleRows.length)} از {toFa(totalCount)}</div>
        </div>

        <div style={s.tableWrap}>
          <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
            <thead style={{position:'sticky',top:0,zIndex:3}}>
              <tr>
                <TH idx={0}>ردیف</TH>
                <TH idx={1}>کد</TH>
                <TH idx={2}>کد Cms</TH>
                <TH idx={3} right>عنوان</TH>
                <TH idx={4} right>نام اختصاری</TH>
                <TH idx={5}>شهر</TH>
                <TH idx={6}>شناسه ملی</TH>
                <TH idx={7}>شناسه واریز</TH>
                <TH idx={8} right>نام مسئول</TH>
                <TH idx={9}>تعداد طرح</TH>
                <TH idx={10}>تعداد تراکنش های طرح</TH>
                <TH idx={11}>تعداد سپرده</TH>
              </tr>
            </thead>
            <tbody>
              {visibleRows.length===0&&!loading&&(<tr><td colSpan={12} style={s.empty}>📭 رکوردی یافت نشد</td></tr>)}
              {visibleRows.map((r,i)=>{
                const sel=selected?.id===r.id;
                const bg=sel?'#64b5f6':i%2===0?'#fff':'#fdf6e3';
                return(<tr key={r.id} onClick={()=>setSelected(r)} style={{cursor:'pointer',background:bg}}
                  onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#bbdefb';}}
                  onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=bg;}}>
                  <td style={s.td}>{toFa(i+1)}</td>
                  <td style={s.td}>{toFa(r.code)}</td>
                  <td style={s.td}>{toFa(r.cms_code)}</td>
                  <td style={{...s.td,textAlign:'right',fontWeight:'600'}}>{r.title}</td>
                  <td style={{...s.td,textAlign:'right'}}>{r.brief_name}</td>
                  <td style={s.td}>{r.city_name}</td>
                  <td style={{...s.td,direction:'ltr'}}>{r.national_code}</td>
                  <td style={{...s.td,direction:'ltr'}}>{r.pay_id_no}</td>
                  <td style={{...s.td,textAlign:'right'}}>{r.manager_name}</td>
                  <td style={s.td}>{numFmt(r.program_count)}</td>
                  <td style={s.td}>{numFmt(r.turnover_count)}</td>
                  <td style={s.td}>{numFmt(r.deposit_count)}</td>
                </tr>);
              })}
            </tbody>
          </table>
        </div>
        <LoadMoreButton onClick={()=>fetchData(false)} loading={loading}/>
      </main>

      {/* مودال جدید/ویرایش */}
      {(modal==='new'||modal==='edit')&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={s.modal} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}><div style={s.mTitle}>{modal==='new'?'➕ واحد اجرایی جدید':'✎ ویرایش واحد اجرایی'}</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <div style={s.row}>
                <FInput label="عنوان" name="title" value={form.title} onChange={handleChange} half/>
                <FInput label="نام اختصاری" name="brief_name" value={form.brief_name} onChange={handleChange} half/>
              </div>
              <div style={s.row}>
                <FInput label="کد" name="code" value={form.code} onChange={handleChange} type="number" half/>
                <FInput label="کد Cms" name="cms_code" value={form.cms_code} onChange={handleChange} type="number" half/>
              </div>
              <div style={s.row}>
                <FInput label="شناسه ملی" name="national_code" value={form.national_code} onChange={handleChange} half/>
                <FInput label="شناسه واریز" name="pay_id_no" value={form.pay_id_no} onChange={handleChange} half/>
              </div>
              <div style={s.row}>
                <CityLookup value={form.city_id} displayName={form.city_name}
                  onChange={(id,name)=>setForm(p=>({...p,city_id:id,city_name:name}))}/>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={handleSave} style={s.btnSave}>ثبت</button>}
            </div>
          </div>
        </div>
      )}

      {/* مودال حذف */}
      {modal==='delete'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'440px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={s.mTitle}>⚠️ تأیید حذف</div><button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <p style={{fontSize:'14px',lineHeight:'2'}}>آیا از حذف واحد اجرایی «<b>{selected.title}</b>» مطمئن هستید؟</p>
              <p style={{fontSize:'12px',color:'#888'}}>در صورت استفاده در اسناد حسابداری، بودجه یا سپرده، حذف امکان‌پذیر نیست.</p>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
              {vbf.can('BTNDELETE') && <button onClick={handleDelete} style={{...s.btnSave,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>حذف</button>}
            </div>
          </div>
        </div>
      )}

      {/* مودال مسئول واحد */}
      {mgrModal&&selected&&(
        <div style={s.overlay} onClick={()=>setMgrModal(false)}>
          <div style={{...s.modal,maxWidth:'560px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#006064,#00838f)'}}>
              <div style={s.mTitle}>👤 مسئول واحد — {selected.title}</div>
              <button onClick={()=>setMgrModal(false)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {/* فرم افزودن مسئول جدید */}
              <div style={{...s.row,alignItems:'flex-end'}}>
                <div ref={peopleRef} style={{position:'relative',flex:'0 0 55%'}}>
                  <label style={{fontSize:'12px',fontWeight:'600',color:'#555',display:'block',marginBottom:'4px'}}>مسئول جدید</label>
                  <input value={mgrPeopleName} onChange={e=>searchPeople(e.target.value)}
                    onFocus={()=>{if(peopleResults.length)setPeopleOpen(true);}}
                    placeholder="نام / کد پرسنلی..."
                    style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
                      fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',width:'100%',boxSizing:'border-box'}}/>
                  {peopleOpen&&peopleResults.length>0&&(
                    <div style={{position:'absolute',top:'100%',right:0,left:0,background:'#fff',border:'1px solid #ccc',
                      borderRadius:'8px',maxHeight:'180px',overflowY:'auto',zIndex:50,boxShadow:'0 8px 24px rgba(0,0,0,0.2)'}}>
                      {peopleResults.map(p=>(
                        <div key={p.id} onClick={()=>selectPerson(p)}
                          style={{padding:'8px 12px',cursor:'pointer',fontSize:'13px',borderBottom:'1px solid #f0f0f0'}}
                          onMouseEnter={e=>e.currentTarget.style.background='#e3f2fd'}
                          onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                          {p.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{flex:'0 0 30%'}}>
                  <label style={{fontSize:'12px',fontWeight:'600',color:'#555',display:'block',marginBottom:'4px'}}>تاریخ</label>
                  <input value={mgrDate} onChange={e=>setMgrDate(e.target.value)} placeholder="۱۴۰۵/۰۱/۰۱" maxLength={10}
                    style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
                      fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'ltr',width:'100%',boxSizing:'border-box'}}/>
                </div>
                {vbf_departmentsmanager.can('BTNOK') && vbf_departmentsmanager.can(mgrEditId?'BTNEDIT':'BTNNEW') && <button onClick={addManager} style={{...s.btnSave,padding:'8px 14px',whiteSpace:'nowrap'}}>{mgrEditId?'ثبت ویرایش':'＋ افزودن'}</button>}
                {mgrEditId>0 && <button onClick={()=>{setMgrEditId(0);setMgrPeopleId(0);setMgrPeopleName('');setMgrDate('');}} style={{...s.btnCancel,padding:'8px 12px'}}>لغو</button>}
              </div>
              {/* لیست مسئولین */}
              {managers.length>0?(
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px',marginTop:'12px'}}>
                  <thead><tr style={{background:'#f0f2f7'}}>
                    <th style={{padding:'8px',border:'1px solid #e0e0e0',textAlign:'right'}}>مسئول</th>
                    <th style={{padding:'8px',border:'1px solid #e0e0e0',width:'100px'}}>تاریخ</th>
                    <th style={{padding:'8px',border:'1px solid #e0e0e0',width:'60px'}}>عملیات</th>
                  </tr></thead>
                  <tbody>{managers.map(m=>(
                    <tr key={m.id}>
                      <td style={{padding:'6px 8px',border:'1px solid #e0e0e0',textAlign:'right',fontWeight:'600'}}>{m.name}</td>
                      <td style={{padding:'6px 8px',border:'1px solid #e0e0e0',textAlign:'center',direction:'ltr'}}>{toFa(m.date)}</td>
                      <td style={{padding:'6px 8px',border:'1px solid #e0e0e0',textAlign:'center'}}>
                        {vbf_departmentsmanager.can('BTNEDIT') && <button onClick={()=>editManager(m)}
                          style={{background:'#bbdefb',border:'none',borderRadius:'4px',color:'#1a237e',cursor:'pointer',
                            padding:'2px 8px',fontSize:'12px',fontFamily:'inherit',marginLeft:'4px'}}>ویرایش</button>}
                        {vbf_departmentsmanager.can('BTNDELETE') && <button onClick={()=>deleteManager(m.id)}
                          style={{background:'#ffcdd2',border:'none',borderRadius:'4px',color:'#b71c1c',cursor:'pointer',
                            padding:'2px 8px',fontSize:'12px',fontFamily:'inherit'}}>حذف</button>}
                      </td>
                    </tr>
                  ))}</tbody>
                </table>
              ):(
                <div style={{textAlign:'center',padding:'20px',color:'#999',fontSize:'13px'}}>مسئولی ثبت نشده است</div>
              )}
            </div>
            <div style={s.mFooter}><button onClick={()=>setMgrModal(false)} style={s.btnCancel}>بستن</button></div>
          </div>
        </div>
      )}

      {changing&&selected&&(
        <ChangeUsesDialog api={incomeApi} base="/departments" rec={selected} canMove={vbf.can('BTNMOVE')}
          onClose={()=>setChanging(false)} onMessage={m=>setMsgLines([m])}
          onMoved={()=>{setChanging(false);setAfterMove(true);}}/>
      )}
      {afterMove&&(
        <AfterMoveAsk onNo={()=>{setAfterMove(false);fetchData(true);}}
          onYes={()=>{setAfterMove(false);if(vbf.can('BTNDELETE'))handleDelete();else fetchData(true);}}/>
      )}
      <MsgBox lines={msgLines} onClose={()=>setMsgLines([])}/>
      {toast&&<div style={s.toast}>{toast}</div>}
    </div>
  );
}

const s={
  page:{height:'100vh',overflow:'hidden',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl',display:'flex',flexDirection:'column'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'10px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',flexShrink:0},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'8px 20px',flex:1,display:'flex',flexDirection:'column',overflow:'hidden',minHeight:0},
  toolbar:{display:'flex',alignItems:'center',gap:'8px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolBtns:{display:'flex',gap:'7px'},
  fL:{fontSize:'11px',fontWeight:'600',color:'#555'},
  fI:{padding:'7px 11px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right'},
  btnNew:{padding:'7px 16px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnEdit:{padding:'7px 16px',background:'linear-gradient(135deg,#1a237e,#283593)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnDel:{padding:'7px 16px',background:'linear-gradient(135deg,#b71c1c,#c62828)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnMgr:{padding:'7px 16px',background:'linear-gradient(135deg,#006064,#00838f)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnRefresh:{padding:'7px 12px',background:'linear-gradient(135deg,#37474f,#455a64)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  countBadge:{padding:'4px 10px',background:'#1a2f50',color:'#C8A84B',borderRadius:'16px',fontSize:'11px',fontWeight:'700'},
  tableWrap:{overflowX:'auto',overflowY:'auto',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',background:'#fff',flex:1,minHeight:0},
  td:{padding:'7px 9px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  empty:{textAlign:'center',padding:'48px',color:'#999',fontSize:'14px'},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:{background:'#fff',borderRadius:'16px',width:'100%',maxWidth:'640px',maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'},
  mHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',borderRadius:'16px 16px 0 0'},
  mTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  closeBtn:{background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'13px',display:'flex',alignItems:'center',justifyContent:'center'},
  mBody:{overflowY:'auto',flex:1,padding:'18px'},
  mFooter:{display:'flex',justifyContent:'flex-end',gap:'10px',padding:'12px 18px',borderTop:'1px solid #f0f2f7',background:'#f8f9fa',borderRadius:'0 0 16px 16px'},
  row:{display:'flex',gap:'12px',marginBottom:'12px',flexWrap:'wrap'},
  errBox:{background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',padding:'10px 14px',color:'#c62828',marginBottom:'10px',fontSize:'13px'},
  btnCancel:{padding:'8px 18px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  btnSave:{padding:'8px 22px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  toast:{position:'fixed',bottom:'24px',right:'24px',background:'#1b5e20',color:'#fff',padding:'12px 24px',borderRadius:'10px',fontSize:'14px',fontWeight:'600',zIndex:2000,boxShadow:'0 4px 16px rgba(0,0,0,0.25)'},
};